import { useCallback } from 'react';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface UnDeleteInvoiceRequest {
  invoiceIds?: any[];
}

const useUnDeleteInvoicesApi = () => {
  const call = useCallback(async ({ invoiceIds }: UnDeleteInvoiceRequest = {}) => {
    try {
      const res = await axiosInstance.post(`/Invoice/UnDelete`, invoiceIds);
      return res;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { isLoading, execute } = useAsync(call, false);

  return { unDeleteInvoices: execute, unDeleteInvoiceLoading: isLoading };
};

export default useUnDeleteInvoicesApi;
